import React, { useContext } from 'react';

import { Utils } from '@adobe/aem-react-editable-components';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import 'global/multiThemingStyling/multiClientGlobalVariables.scss';
import 'global/style/BaseTenantStyle.sass';

import { getHomepagePath } from 'utils/UrlUtil';

import './ErrorPopup.sass';

export const ErrorPopup = () => {
  const { showError, setShowError } = useContext(ErrorHandlingContext);
  const isEditor = Utils.isInEditor();
  return (
    <CustomModal
      isOpen={showError && !isEditor}
      title="Fehler!"
      content={
        <div className="form-popup__content">
          Problem bei der Anfrage. Bitte versuchen Sie es später erneut.
        </div>
      }
      ctaButtons={
        <ActionButton
          title={<span className="form-popup__cta-button-ok">OK</span>}
          link={getHomepagePath()}
          inverted
          onClick={() => {
            setShowError(false);
          }}
        />
      }
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    />
  );
};
